import { IDonorProfileDonorData } from '@nkr/models/donor-profile';

export const updateProfileDonorData = {
    onNumericChange: (name: string, value: number, data: IDonorProfileDonorData) => {
        switch (name) {
            case 'matchStatus': data.matchStatus = value; break;
            case 'declinedAdpReason': data.declinedAdpReason = value; break;
            case 'surgeonContactId': data.surgeonContactId = value; break;
            case 'coordinatorId': data.coordinatorId = value; break;
            case 'didRemoteWorkup': data.didRemoteWorkup = value; break;
            case 'rdnCenterId': data.rdnCenterId = value; break;
        }

        return data;
    },

    onTextChange: (name: string, value: string, data: IDonorProfileDonorData) => {
        switch (name) {
            case 'alias': data.alias = value; break;
            case 'registrationDate': data.registrationDate = value; break;
            case 'mrn': data.mrn = value; break;
            case 'crossReferenceHint': data.crossReferenceHint = value; break;
            case 'declinedAdpReasonOther': data.declinedAdpReasonOther = value; break;
            case 'donationStartDate': data.donationStartDate = value; break;
            case 'donationEndDate': data.donationEndDate = value; break;
            case 'unosId': data.unosId = value; break;
            case 'remoteWorkupDate': data.remoteWorkupDate = value; break;
            case 'comments': data.comments = value; break;
            case 'relationshipToRecipient': data.relationshipToRecipient = value; break;
            case 'relationshipToPatientOther': data.relationshipToPatientOther = value; break;
        }

        return data;
    },

    onBooleanChange: (name: string, value: boolean, data: IDonorProfileDonorData) => {
        switch (name) {
            case 'isActive': data.isActive = value; break;
            case 'hasFrozenSamples': data.hasFrozenSamples = value; break;
            case 'isViableBridge': data.isViableBridge = value; break;
            case 'isWorkedUp': data.isWorkedUp = value; break;
            case 'usePhlebotomy': 
                data.usePhlebotomy = value;
                if (value === true) {
                    data.directXmSend = true;
                    data.directSerologySend = true;
                }
                break;
            case 'directXmSend': data.directXmSend = value; break;
            case 'directSerologySend': data.directSerologySend = value; break;
            case 'directCryoSend': data.directCryoSend = value; break;
            case 'voucherConsentsReviewed': data.voucherConsentsReviewed = value; break;
        }

        return data;
    }
}